import React from 'react';
import { Icon } from './Icon.js';
export const IconTableRowNewTop2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { y: "6.5", width: "12", height: "5.5", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m8,2h-1.25V.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25h-1.25c-.414,0-.75.336-.75.75s.336.75.75.75h1.25v1.25c0,.414.336.75.75.75s.75-.336.75-.75v-1.25h1.25c.414,0,.75-.336.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconTableRowNewTop2Fill12.js.map